document.addEventListener("DOMContentLoaded", () => {
    const searchOverlay = document.querySelector(".search-overlay");
    const searchContainer = document.querySelector(".search-container");
    const searchIcon = document.getElementById("search-icon-custom");
    const searchClose = document.querySelector(".search-close");
    const searchInput = document.getElementById("search-input");
    const clearText = document.getElementById("clear-text");
    //const didYouMean = document.getElementById("did-you-mean");
    const emptyState = document.getElementById("empty-state");
    const searchResults = document.getElementById("search-results");

    // Open search popup
    searchIcon.addEventListener("click", () => {
        searchOverlay.classList.add("active");
        document.body.classList.add("no-scroll");
        searchInput.focus();
        searchContainer.style.transform = "translateY(0)";
        searchContainer.style.opacity = "1";
    });

    // Close search popup
    searchClose.addEventListener("click", () => {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("no-scroll");
    });

    // Clear text field
    clearText.addEventListener("click", () => {
        searchInput.value = "";
        updateSearchState(); // Update UI elements like clear button, empty state
    });

    // Handle input changes with debounce (for suggestions or UI updates)
    let debounceTimer;
    searchInput.addEventListener("input", () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(updateSearchState, 200);
    });

    // Handle "Enter" key press to navigate to search results page
    searchInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            const query = searchInput.value.trim();
            if (query.length >= 1) {
                clearTimeout(debounceTimer);
                const searchPageUrl = `/search?q=${encodeURIComponent(query)}`;
                window.location.href = searchPageUrl;
            }
        }
    });

    // This function now primarily handles the visibility of UI elements
    // like the clear button, "did you mean", and empty state.
    // If you were fetching live suggestions here, that logic would remain.
    function updateSearchState() {
        const query = searchInput.value.trim();
        const hasTextForUI = query !== "";
        const hasSufficientTextForSearch = query.length >= 3;

        clearText.style.display = hasTextForUI ? "block" : "none";
        // if (hasSufficientTextForSearch) {
        //     didYouMean.innerHTML = `<strong>Did you mean?</strong> <a href="/search?q=${encodeURIComponent(query)}" class="btn-link-hover">${query}</a>`;
        //     emptyState.style.display = "none";
        // } else {
        //     didYouMean.innerHTML = "";
        //     emptyState.style.display = "grid";
        // }
    }
});